const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  size: state => state.app.size,
  userType: state => state.user.userType,
  projectTitle: state => state.setting.projectTitle,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  introduction: state => state.user.introduction,
  permission_routes: state => state.permission.routes,
  permission: state => state.permission.permission,
  roles: state => state.user.roles,
  errorLogs: state => state.errorLog.logsm,
}
export default getters

